module.exports = __webpack_public_path__ + "static/img/fish39.db6308c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish39.png
// module id = h8mY
// module chunks = 0